import { getCookie } from 'lib/cookie'
import { ISmartAlertMarketplaceDocument } from 'services/Home/widgets/SmartAlert/interface'

function generalFilter(
  alert: ISmartAlertMarketplaceDocument,
  page: string,
): boolean {
  const currentTime = new Date().getTime()
  const cookieName = `${page}-${alert.alert_key}`
  const startDate = alert.configuration.start_date
  const endDate = alert.configuration.end_date
  return (
    alert.is_active &&
    currentTime >= startDate.seconds * 1000 &&
    currentTime <= endDate.seconds * 1000 &&
    currentTime >= Number(getCookie(cookieName) ?? 0)
  )
}

export default generalFilter
